import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ModalWrapperContainer } from './ModalWrapper.styles';

/**
 * `ModalWrapper` wraps children components and presents them as a modal.
 *
 * @throws {Error} If `backdropClosesModal` is true but `closeModal` is undefined
 *
 * @public
 * @author Alex Kasemir
 */
class ModalWrapper extends Component {
  handleBackDropClick = (e) => {
    if (e.target !== e.currentTarget) return;

    this.props.closeModal();
  };

  render() {
    const { isOpen, children, className, backdropClosesModal } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <ModalWrapperContainer
        className={className || ``}
        onClick={backdropClosesModal ? this.handleBackDropClick : null}
      >
        {children}
      </ModalWrapperContainer>
    );
  }
}

ModalWrapper.defaultProps = {
  isOpen: true,
};

const checkBackdrop = (backdropClosesModal, closeModal, componentName) => {
  let error;
  if (
    typeof backdropClosesModal !== `undefined`
    && typeof backdropClosesModal !== `boolean`
  ) {
    error = new Error(
      `backdropClosesModal should be a boolean in '${componentName}'`,
    );
  } else if (backdropClosesModal && !closeModal) {
    error = new Error(
      `If backdropClosesModal then you must provide a closeModal function in '${componentName}'.`,
    );
  }
  return error;
};

ModalWrapper.propTypes = {
  className: PropTypes.string,
  /** The contents of the modal */
  children: PropTypes.object.isRequired,
  /** A function that handles dismissing a modal */
  closeModal: PropTypes.func,
  /** Should clicking outside the modal close it? If true, you must provide closeModal */
  backdropClosesModal: (props, propName, componentName) => {
    return checkBackdrop(
      props.backdropClosesModal,
      props.closeModal,
      componentName,
    );
  },
  /** Is the modal visible? */
  isOpen: PropTypes.bool.isRequired,
};

export default ModalWrapper;
